/**
 * The Grid's scale and the page's colours, shared by the canvas and the hits
 * drawn on it. Greyscale but for two colours with one job each: the Walker's
 * red, for the Walker and everything it does, and the hands' cyan, its
 * complement, for every Visitor's cursor and what their hands change. The same
 * two are in index.html.
 */

import { GRID_SIDE } from "./world.ts"

export const CELL_PX = 29
export const GRID_PX = GRID_SIDE * CELL_PX
/**
 * The open space the canvas keeps round the Grid, so a hit near an edge, or
 * the Walker reaching across it, spills out rather than being cut off square.
 */
export const MARGIN_PX = CELL_PX * 3

export const GROUND = "#0c0c0c"
export const WALKER = "#ee1133"
export const HANDS = "#14e0d0"
